import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ResidentialSolarPage = lazy(() => import('../pages/solutions/residential/page'));
const CommercialSolarPage = lazy(() => import('../pages/solutions/commercial/page'));
const OffGridPage = lazy(() => import('../pages/solutions/offgrid/page'));
const SolarKitsPage = lazy(() => import('../pages/products/solar-kits/page'));
const StreetlightsPage = lazy(() => import('../pages/products/streetlights/page'));
const PumpsPage = lazy(() => import('../pages/products/pumps/page'));
const BatteriesPage = lazy(() => import('../pages/products/batteries/page'));
const InvertersPage = lazy(() => import('../pages/products/inverters/page'));
const ProjectsPage = lazy(() => import('../pages/projects/page'));
const SupportPage = lazy(() => import('../pages/support/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const QuotePage = lazy(() => import('../pages/quote/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/solutions/residential',
    element: <ResidentialSolarPage />,
  },
  {
    path: '/solutions/commercial',
    element: <CommercialSolarPage />,
  },
  {
    path: '/solutions/offgrid',
    element: <OffGridPage />,
  },
  {
    path: '/products/solar-kits',
    element: <SolarKitsPage />,
  },
  {
    path: '/products/streetlights',
    element: <StreetlightsPage />,
  },
  {
    path: '/products/pumps',
    element: <PumpsPage />,
  },
  {
    path: '/products/batteries',
    element: <BatteriesPage />,
  },
  {
    path: '/products/inverters',
    element: <InvertersPage />,
  },
  {
    path: '/projects',
    element: <ProjectsPage />,
  },
  {
    path: '/support',
    element: <SupportPage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/quote',
    element: <QuotePage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
